import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const Banners = (props) => {
  const lang = useSelector((state) => state.lang);
  return (
    <Swiper
      spaceBetween={30}
      centeredSlides={true}
      autoplay={{
        delay: 3000,
        disableOnInteraction: false,
      }}
      pagination={{
        clickable: true,
        dynamicBullets: true,
      }}
      navigation={true}
      modules={[Autoplay, Pagination, Navigation]}
      className="tf-slideshow slider-effect-fade slider-skincare position-relative"
    >
      {props.data.map((banner, index) => (
        <SwiperSlide key={index}>
          <div className="wrap-slider">
            <img
              className="lazyload"
              data-src={banner.image}
              src={banner.image}
              alt="skincare-slideshow-01"
              loading="lazy"
            />
            <div className="box-content text-center">
              <div className="container">
                <Link
                  to={banner.link !== "" ? banner.link : "#"}
                  className="fade-item fade-item-3 tf-btn btn-light-icon animate-hover-btn btn-xl radius-3"
                >
                  <span>{lang === "ar" ? banner.title_ar : banner.title}</span>
                </Link>
              </div>
            </div>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default Banners;
